/**
 * Dealer inventory filter helpers (Dealer Profile M8).
 */
import { applyVehicleSearchFilters } from "../vehicleSearch/vehicleSearchFilters";
import {
  buildVehicleSearchFilterChips,
  removeFilterChip,
} from "../vehicleSearch/vehicleSearchFilterChips";
import {
  getPublicDealerInventoryListings,
  isListingEligibleForDealerProfileInventory,
  listingBelongsToDealer,
} from "./dealerInventoryEligibility";
import { parseDealerInventorySearchParams } from "../../constants/dealerInventorySearchParamsConstants";

export function applyDealerInventoryFilters(listings, params, dealer) {
  const parsed = parseDealerInventorySearchParams(params);
  const filtered = applyVehicleSearchFilters(listings, parsed);
  if (!dealer) return filtered;
  return filtered.filter(
    (listing) =>
      listingBelongsToDealer(listing, dealer) &&
      isListingEligibleForDealerProfileInventory(listing, dealer)
  );
}

export function getDealerInventoryAvailableFilters(listings = []) {
  const makes = new Set();
  const modelsByMake = new Map();
  const bodyTypes = new Set();
  const transmissions = new Set();
  const fuelTypes = new Set();
  const fairPriceLabels = new Set();
  const riskLevels = new Set();
  let hasPhotosOption = false;

  listings.forEach((listing) => {
    if (listing.make) {
      makes.add(listing.make);
      if (listing.model) {
        if (!modelsByMake.has(listing.make)) modelsByMake.set(listing.make, new Set());
        modelsByMake.get(listing.make).add(listing.model);
      }
    }
    if (listing.bodyType && listing.bodyType !== "unknown") bodyTypes.add(listing.bodyType);
    if (listing.transmission) transmissions.add(listing.transmission);
    if (listing.fuelType) fuelTypes.add(listing.fuelType);
    if (listing.fairPriceLabel) fairPriceLabels.add(listing.fairPriceLabel);
    if (listing.riskLevel) riskLevels.add(listing.riskLevel);
    if (listing.primaryImageUrl) hasPhotosOption = true;
  });

  return {
    makes: [...makes].sort(),
    modelsByMake: Object.fromEntries(
      [...modelsByMake.entries()].map(([make, models]) => [make, [...models].sort()])
    ),
    bodyTypes: [...bodyTypes].sort(),
    transmissions: [...transmissions].sort(),
    fuelTypes: [...fuelTypes].sort(),
    fairPriceLabels: [...fairPriceLabels].sort(),
    riskLevels: [...riskLevels].sort(),
    hasPhotosOption,
  };
}

export function buildDealerInventoryFilterChips(params) {
  return buildVehicleSearchFilterChips(params).filter(
    (chip) => !["city", "keyword", "dealerVerified"].includes(chip.key)
  );
}

export { removeFilterChip as removeDealerInventoryFilterChip };

export function resetDealerInventoryModelForMake(params, make, modelsForMake = []) {
  if (!params.model) return params;
  if (!make) return { ...params, model: null, page: 1 };
  const belongs = modelsForMake.some(
    (model) => String(model).toLowerCase() === String(params.model).toLowerCase()
  );
  return belongs ? params : { ...params, model: null, page: 1 };
}
